import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { faqs } from "./components/FAQ";
import Navbar from "@/components/feature/Navbar";
import DiagnosticVideo from "@/components/feature/DiagnosticVideo";
import Footer from "@/components/feature/Footer";
import FloatingButton from "@/components/feature/FloatingButton";
import Avis from "@/components/feature/Avis";
import Hero from "./components/Hero";
import Reassurances from "./components/Reassurances";
import ManuelVersElectrique from "./components/ManuelVersElectrique";
import CommentSeDeroule from "./components/CommentSeDeroule";
import Avantages from "./components/Avantages";
import SansRemplacer from "./components/SansRemplacer";
import CTAAppel from "./components/CTAAppel";
import FAQ from "./components/FAQ";
import Galerie from "./components/Galerie";
import Maillage from "./components/Maillage";
import Formulaire from "./components/Formulaire";

export default function ElectrificationSomfyPage() {
  return (
    <div className="font-sans">
      <SEOHead
        title="Électrification Volet Roulant Strasbourg | Somfy"
        description="Électrification volet roulant Somfy à Strasbourg et dans le Bas-Rhin. Protocoles io et RTS, domotique, sans changer le tablier, devis gratuit. 03 74 47 32 40."
        path="/electrification-somfy"
        type="service"
        serviceType="Électrification de volet roulant"
        faqs={faqs}
        breadcrumbs={[{ label: "Accueil", href: "/" }, { label: "Électrification Somfy" }]}
      />
      <Navbar />
      <Breadcrumb items={[{ label: "Accueil", href: "/" }, { label: "Électrification Somfy" }]} />
      <main>
        <Hero />
        <DiagnosticVideo />
        <Reassurances />
        <ManuelVersElectrique />
        <CommentSeDeroule />
        <Avantages />
        <SansRemplacer />
        <CTAAppel />
        <FAQ />
        <Galerie />
        <Maillage />
        <Formulaire />
        <Avis />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}